<template>
  <!-- Footer -->
  <mdb-footer color="blue" class="fixed-bottom font-small pt-1 mt-1 " style=" z-index:-1;">
    <div class="footer-copyright text-center py-1 my-footer">
      <mdb-container fluid>
        &copy; 2019 Copyright: <a href="mailto:support@yoursynchronicity.com">BranchOfApp - v1.0</a>
      </mdb-container>
    </div>
  </mdb-footer>
  <!-- Footer -->
</template>

<script>
    import {mdbCol, mdbContainer, mdbFooter, mdbRow} from 'mdbvue';

    export default {
        name: 'footerComponent',
        components: {
            mdbFooter,
            mdbContainer,
            mdbRow,
            mdbCol
        }
    }
</script>
<style>

  @media (max-width: 720px) {
    .my-footer {
      display: none;
    }
  }
</style>

